import { useState, useEffect } from "react";
import { Box, Button, Modal, TextField } from "@mui/material";
import SelectInput from "../../Select/SelectInput";
import cnpjMask from "../../../utils/cnpj-mask";
import { getStates } from "../../../services/state-service";
import { modalStyle } from "../../../utils/modal-style";
import { createCompany } from "../../../services/company-service";

export default function CreateCompanyModal({ name, id, open, setOpen }) {
  const accessToken = localStorage.getItem("token");
  const handleClose = () => setOpen(false);
  const [errorCnpj, setErrorCnpj] = useState({ message: "", status: false });
  const [selectedUf, setSelectedUf] = useState("");
  const [selectValues, setSelectValues] = useState({
    states: [],
    products: [],
  });
  const [formValues, setFormValues] = useState({
    name: "",
    cnpj: "",
    comissao_produto: "",
    icms: "",
  });

  function handleCnpj(e) {
    if (cnpjMask(e.target.value) === "") {
      return setErrorCnpj({ message: "Favor digite o cnpj", status: true });
    }
    setErrorCnpj({ message: "", status: false });
  }

  function handleChangeCnpj(e) {
    setFormValues((prevState) => ({
      ...prevState,
      [e.target.name]: cnpjMask(e.target.value),
    }));
  }

  function handleChange(e) {
    setFormValues((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const data = {
      ...formValues,
      state_id: selectedUf,
    };

    try {
      const result = await createCompany(accessToken, data);

      console.log(result);

      return alert("Empresa cadastrada com sucesso.");
    } catch (error) {
      alert("Algo deu errado, favor tentar novamente.");
    }
  }

  useEffect(() => {
    async function getData() {
      const states = await getStates(accessToken);

      setSelectValues((prevState) => {
        return {
          ...prevState,
          states,
        };
      });
    }
    getData();
  }, [accessToken]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="box-container" sx={modalStyle}>
        <form onSubmit={handleSubmit} className="form-container">
          <TextField
            label="Nome"
            name="name"
            onChange={handleChange}
            inputProps={{
              autoComplete: "off",
            }}
          />

          <TextField
            error={errorCnpj.status}
            name="cnpj"
            label="Cnpj"
            value={formValues.cnpj}
            onChange={handleChangeCnpj}
            onBlur={handleCnpj}
            helperText={errorCnpj.message}
            inputProps={{
              autoComplete: "off",
            }}
          />

          <SelectInput
            value={selectedUf}
            name="Estado"
            setValue={setSelectedUf}
            selectValues={selectValues.states}
          />

          <TextField
            label="Icms"
            name="icms"
            type="number"
            onChange={handleChange}
            inputProps={{
              autoComplete: "off",
              step: "0.0001",
            }}
          />

          <TextField
            label="Comissão para Produto"
            name="comissao_produto"
            onChange={handleChange}
            type="number"
            inputProps={{
              autoComplete: "off",
              step: "0.0001",
            }}
          />

          <TextField
            label="Custo de Km"
            name="custo_km"
            type="number"
            onChange={handleChange}
            inputProps={{
              autoComplete: "off",
              step: "0.0001",
            }}
          />

          <TextField
            label="Custo de Partida"
            name="custo_partida"
            type="number"
            onChange={handleChange}
            inputProps={{
              autoComplete: "off",
              step: "0.0001",
            }}
          />

          <Button type="submit" variant="contained">
            Cadastrar
          </Button>
        </form>
      </Box>
    </Modal>
  );
}
